document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-mobile-toggle]');
  const nav = document.querySelector('[data-mobile-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
  }

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    const form = select.closest('form');
    if (!form) return;
    const hidden = form.querySelector('input[name="id"]');
    const price = form.closest('.product-info')?.querySelector('[data-product-price]');
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      if (hidden) hidden.value = option.value;
      if (price && option.dataset.price) price.textContent = option.dataset.price;
    });
  });
});


document.addEventListener('DOMContentLoaded', () => {
  const turnPage = document.querySelector('[data-turn-page]');
  if (turnPage) {
    const button = turnPage.querySelector('[data-turn-button]');
    const textarea = turnPage.querySelector('textarea');
    const reset = turnPage.querySelector('[data-turn-reset]');
    if (button) {
      button.addEventListener('click', () => {
        if (textarea) textarea.value = '';
        turnPage.classList.add('is-turned');
        turnPage.querySelector('.turn-page__result')?.focus();
      });
    }
    if (reset) {
      reset.addEventListener('click', () => {
        turnPage.classList.remove('is-turned');
        if (textarea) textarea.focus();
      });
    }
  }
});
